import axiosInstance from "../utils/axiosInstance";
import { TokenDecrypt } from "../utils/encryptionDecryption";
const mapToOptions = (data, labelKey = "name", valueKey = "code") => {
  return data.map((item) => ({ label: item[labelKey], value: item[valueKey] }));
};
export const getModuleFromServer = async (page = 1,pageSize = 10) => {
  try {
    const response = await axiosInstance.get(`modules?page=${page}&limit=${pageSize}`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (response && response.data && response.data.encryptedData) {
      const decryptedData = TokenDecrypt(response.data.encryptedData);
      return decryptedData.data;
    }
    return [];
  } catch (error) {
    console.error("Error fetching modules:", error);
    throw new Error("Failed to fetch modules");
  }
};

export const addModule = async (moduleData) => {
  try {
    const jsonData = Object.fromEntries(moduleData.entries());
    const response = await axiosInstance.post("modules", jsonData, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  } catch (error) {
    console.error("Error adding Module:", error);
    throw new Error("Failed add Module");
  }
};

export const updateModule = async (moduleId, moduleData) => {
  try {
    const jsonData = Object.fromEntries(moduleData.entries());
    const response = await axiosInstance.put(`modules/${moduleId}/update`, jsonData, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error updating Module:", error);
    throw new Error("Failed to update Module");
  }
};

export const deleteModule = async (id) => {
  try {
    const response = await axiosInstance.delete(`/modules/${id}`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || "Failed to delete module.";
    console.error("Error in module:", errorMessage);
    throw new Error(errorMessage);
  }
};